import Repository from "./Repository";
import { TrainingCategory } from "../types/TrainingCategory";
import TrainingCategoriesResponse from "./response/TrainingCategoriesResponse";
import TrainingCategoryResponse from "./response/TrainingCategoryResponse";
import Axios from "axios";

const resource = "/trainingCategory";

export default {
  getByCompany(companyId: string) {
    return Repository.get<TrainingCategoriesResponse>(
      `${resource}/company/${companyId}`
    );
  },
  save(category: TrainingCategory) {
    if (category.trainingCategoryId) {
      return Repository.patch<TrainingCategoryResponse>(
        `${resource}`,
        category
      );
    } else {
      return Repository.post<TrainingCategoryResponse>(`${resource}`, category);
    }
  },
  saveAll(categories: TrainingCategory[]) {
    let reqs: any = [];
    for (let c of categories) {
      reqs.push(this.save(c));
    }
    return Axios.all(reqs);
  },
  seedDefaultCategories(companyId: string) {
    return Repository.post(
      `${resource}/company/${companyId}/defaultCategories`
    );
  }
};
